import React from 'react';
import { NamedLink } from '../../../components';
import IconArrowTop from '../../../components/IconArrowTop/IconArrowTop';
import moment from 'moment';
// import { isArrayLength, keepValidCMSChars } from '../../../util/genericHelpers';

import css from '../BlogPage.module.css';
import { convertStrapiRichTextToReact, extractPlainTextFromStrapiRichText } from '../../../util/richTextHelpers';
import { convertMarkdownToReact } from '../../../util/markdownHelpers';
// import { draftSlug } from '../../../routing/routeConfiguration';
// import { getImagesLink } from '../../../util/dataExtractor';

const baseUrl = process.env.REACT_APP_STRAPI_BASE_URL;
// const baseUrl = 'http://localhost:1337';

const draftSlug = 'draft';
const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

const keepValidCMSChars = inputString => {
  // Ensure input is a string
  const stringInput = inputString ? String(inputString) : '';

  // This regex matches all characters that aren't part of the German alphabet, numerics or spaces
  const regex = /[^a-zA-Z0-9äöüß ]/g;

  // Remove text enclosed within square brackets followed by a URL enclosed within parentheses
  const updatedString = stringInput?.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Replace all matches with an empty string
  return updatedString.replace(regex, ' ');
};

const getImagesLink = (images, url) => {
  // Generate an array of image URLs using the base URL and the image object's URL attribute.
  const imageUrls =
    isArrayLength(images) &&
    images.map(image => {
      const imageUrl = `${url}${image?.attributes?.url}`;
      return imageUrl;
    });

  // Return the array of image URLs.
  return imageUrls;
};

function BlogCard(props) {
  const { blog } = props;

  const blogImages = blog?.coverImage?.formats?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data || blog?.coverImage?.url || blog?.image?.data;
  const tag = blog?.attributes?.tag?.data?.attributes?.name || blog?.tag?.data?.attributes?.name || '';
  const title = blog?.title || blog?.attributes?.title || blog?.title || '';
  const createdAt = blog?.attributes?.createdAt || blog?.createdAt || blog?.publishedAt;
  const description = blog?.description?.[0]?.children?.[0]?.text || blog?.attributes?.description || '';
  const slug = blog?.attributes?.slug || blog?.slug || '';
  const imagesLink = getImagesLink([blogImages], baseUrl);

  const rawDescription = blog?.description || blog?.attributes?.description;
    
  // Extract plain text for meta description
  let descriptionText = '';
  let descriptionContent = null;

  if (Array.isArray(rawDescription)) {
    // It's Strapi rich text format
    descriptionText = extractPlainTextFromStrapiRichText(rawDescription);
    descriptionContent = convertStrapiRichTextToReact(rawDescription);
  } else if (typeof rawDescription === 'string') {
    // It's markdown or plain text
    descriptionText = rawDescription;
    descriptionContent = convertMarkdownToReact(rawDescription);
  }

  return (
    <NamedLink className={css.blog} name="SingleBlogPage" params={{ title: slug || draftSlug }}>
      <>
      <div className={css.blogImg}>
        {blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url ? (
          <img
            src={blog?.coverImage?.formats?.small?.url || blog?.coverImage?.formats?.medium?.url || blog?.coverImage?.url || blog?.coverImage?.formats?.thumbnail?.url || blog?.attributes?.coverImage?.data?.attributes?.url}
            alt={title}
            className={css.blogCoverImage}
          />
        ) : (
          <div className={css.noImagePlaceholder}>No image</div>
        )}
      </div>
      <div className={css.blogDetails}>
        <div className={css.blogPostTime}>
          <div className={css.tagContainer}>
            <span className={css.blogTime}>{tag}</span>
          </div>
          <span className={css.blogTime}>{moment(createdAt).format('DD/MM/YYYY')}</span>
        </div>
        <div className={css.cardTitleSec}>
          <h2 className={css.blogPostTitle}>{title}</h2>
          <IconArrowTop />
        </div>
        {/* <p className={css.blogPostDescription}>{keepValidCMSChars(description)}</p> */}
        <p className={css.blogPostDescription}>{descriptionContent}</p>
      </div>
      </>
    </NamedLink>
  );
}

export default BlogCard;
